
import React, { Component } from 'react'; 
import {Spinner} from 'react-bootstrap';
import _ from 'lodash';
import { connect } from 'react-redux';
import {Tabs, Tab} from 'react-bootstrap';
import {InventoryUserMappedAction, TokenValidation} from '../Dashboard/UserActions';
import {SearchCalibarationAction, SearchQANames, AssignCalibrationAction,
  ShowMessagePopUpFunctionFalse, closeModalPopUp, getCaLibrtionStatus, ResetCalibration} from '../WorkListing/WorklistingAction'
import Calibration from './Calibration';
import CalibrationStatus from './calibrationStatus';
import ShowModalPopUp from '../ShowModalPopUp';
class Calibrationindex extends Component {
  constructor(props){
    super(props)
    this.state={
    }
  }

  componentDidMount(){    
    this.props.actioninventoryUserMapped()
  }
  loadTabContent = (prop) => {
    this.setState({key:prop})
  }
  ScreensComp = () =>{            
    const{key} = this.state
    if(!_.isEmpty(this.props.loginAction)){
    let moduleAccess = _.find(this.props.loginAction.modulescreens, {"moduleUId": "CALIBRATION"})
    let accessPermission = moduleAccess.screens[0].accessPermission
    let returnObj =[]
    _.map(moduleAccess.screens, (obj) =>{ 
        if(obj.screenUId === "HOME_CALIBRATION"){ 
          returnObj.push(<Tab eventKey="HOME_CALIBRATION" title="CALIBRATION ASSIGNMENT" key={1}>          
             <Calibration inventory={this.props.inventoryMapped} size={this.props.size}
              isPending={this.props.isPending}
              action={this.props} searchData={this.props.searchData} QANameList={this.props.QANameList}
              showPopUp ={this.props.showPopUp} accessPermission={accessPermission}
              /> 
          </Tab>)}
        if(obj.screenUId === "STATUS_CALIBRATION"){ 
          returnObj.push(<Tab eventKey="STATUS_CALIBRATION" title="CALIBRATION STATUS" key={2}>
              <CalibrationStatus inventory={this.props.inventoryMapped} action={this.props}
              calibrationStatus={this.props.calibrationStatus}/>
          </Tab>)}
    })
    returnObj =	_.sortBy(returnObj, ['key'])
   return (<Tabs defaultActiveKey={moduleAccess.screens[0].screenUId} transition={false} activeKey={key ? key : returnObj[0].props.eventKey} unmountOnExit={true}
   id="noanim-tab-example" onSelect={(eventKey)=>this.loadTabContent(eventKey)}>
   {returnObj}</Tabs>)
    }
     
  } 
 
  render(){
    let style= true
		if(typeof this.props.size !== 'undefined'){
			style = this.props.size
    }        
    return(
      <div className={(style) ? 'user' : "userSmall"}>        
      {this.props.isPending === true ? <p className='spinner'><Spinner animation="grow" role="status" size='lg'/>
        Loading...</p> : null}
      {(this.props.isPending === true) ? <div className='wrapperSpinner'><span className='spinnerRound'></span></div> : null}
      {(this.props.showerror === true) ? 
      (<ShowModalPopUp message={this.props.errmessage} falseShowModalPopUp={this.props.closeModalPopUp}/>) : null} 
       {this.ScreensComp()}
      </div>   
      )
  }
}    
function mapStateToProps(state){
  return{
   inventoryMapped: state.UserReducer.inventoryMapped,  
   searchData: state.WorklistingReducer.searchData,
   QANameList: state.WorklistingReducer.QANameList,
   showPopUp: state.WorklistingReducer.showPopUp,
   showPopUpmessage:state.WorklistingReducer.showPopUpmessage,
   isPending:state.WorklistingReducer.isPending,
   size: state.UserReducer.large,   
   loginAction: state.LoginReducer.loginAction,
   showModalLogin: state.UserReducer.showModalLogin,
   showerror: state.WorklistingReducer.showerror,
   errmessage: state.WorklistingReducer.errmessage,
   calibrationStatus: state.WorklistingReducer.calibrationStatus
  }  
}

const mapDispatchToProps = (dispatch) => ({
  actioninventoryUserMapped:  () =>dispatch(InventoryUserMappedAction()),
  SearchQANames:  (a) =>dispatch(SearchQANames(a)),
  searchCalibaration:  (a) =>dispatch(SearchCalibarationAction(a)),
  AssignCalibaration:  (a, b) =>dispatch(AssignCalibrationAction(a,b)),
  getCaLibrtionStatus:  (a) =>dispatch(getCaLibrtionStatus(a)),
  ShowMessagePopUpFunctionFalse:  () =>dispatch(ShowMessagePopUpFunctionFalse()),
  TokenValidation : (a) => dispatch(TokenValidation(a)),
  closeModalPopUp: (a) => dispatch(closeModalPopUp()),
  ResetCalibration: (a) => dispatch(ResetCalibration())
  
})

export default connect(mapStateToProps, mapDispatchToProps)(Calibrationindex);


